import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ConsentBanner from "@/components/ConsentBanner";
import Home from "@/pages/Home";
import Books from "@/pages/Books";
import BookDetail from "@/pages/BookDetail";
import Listen from "@/pages/Listen";
import MusicDetail from "@/pages/MusicDetail";
import Watch from "@/pages/Watch";
import Follow from "@/pages/Follow";
import About from "@/pages/About";
import Shop from "@/pages/Shop";
import ShopDetail from "@/pages/ShopDetail";
import Writing from "@/pages/Writing";
import WritingDetail from "@/pages/WritingDetail";
import XLanding from "@/pages/XLanding";
import Offer from "@/pages/Offer";
import DharmaApp from "@/pages/DharmaApp";
import NotFound from "@/pages/NotFound";
import { captureClickIdsAndUTM, getVisitorId, getSessionId } from "@/lib/tracking";

export default function App() {
  // Capture click IDs (fbclid/gclid/etc) + UTM on first load — must run
  // before any per-page event fires so the IDs are persisted to first-party
  // cookies for the rest of the session.
  useEffect(() => {
    captureClickIdsAndUTM();
    // Touch visitor + session ID once so they're seeded.
    getVisitorId();
    getSessionId();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/books" element={<Books />} />
          <Route path="/books/:slug" element={<BookDetail />} />
          {/* /listen is the canonical music route; /music is kept because it
              is already in published captions, bios and video descriptions,
              and a 404 costs a reader more than a duplicate route costs us. */}
          <Route path="/listen" element={<Listen />} />
          <Route path="/listen/:slug" element={<MusicDetail />} />
          <Route path="/music" element={<Listen />} />
          <Route path="/music/:slug" element={<MusicDetail />} />
          <Route path="/watch" element={<Watch />} />
          <Route path="/writing" element={<Writing />} />
          <Route path="/writing/:slug" element={<WritingDetail />} />

          {/* /x — where X and Substack traffic lands. Same article renderer as
              /writing, different footer: exactly one tagged link, per the
              strategy's one-link-per-article rule. */}
          <Route path="/x" element={<XLanding />} />
          <Route path="/x/:slug" element={<WritingDetail variant="x" />} />

          {/* The magnet. /magnet is an alias so a mistyped or legacy link in a
              bio still lands on the offer instead of the 404 page. */}
          <Route path="/offer" element={<Offer />} />
          <Route path="/magnet" element={<Offer />} />
          <Route path="/follow" element={<Follow />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/:slug" element={<ShopDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/dharma" element={<DharmaApp />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      <Footer />
      <ConsentBanner />
    </div>
  );
}
